/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Updatebadge1Inputs */

const id_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perbarui`)
};

const ms_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kemas kini`)
};

const da_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opdater`)
};

const de_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualisieren`)
};

const en_us2_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const es_es2_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizar`)
};

const es_mx2_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizar`)
};

const fil_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const fr_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mise à jour`)
};

const it_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiorna`)
};

const hu_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`frissítés`)
};

const nl_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update`)
};

const no_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oppdater`)
};

const pl_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualizacja`)
};

const pt_br2_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualizar`)
};

const pt_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualização`)
};

const ro_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualizare`)
};

const fi_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`päivitys`)
};

const sv_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uppdatering`)
};

const vi_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cập nhật`)
};

const tr_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`güncelle`)
};

const cs_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualizace`)
};

const bg_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`актуализация`)
};

const ru_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`обновление`)
};

const uk_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`оновлення`)
};

const ar_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث`)
};

const hi_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट`)
};

const th_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดต`)
};

const ja_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const zh_cn2_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const zh_hant1_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ko_sandboxes_updatebadge1 = /** @type {(inputs: Sandboxes_Updatebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트`)
};

/**
* | output |
* | --- |
* | "update" |
*
* @param {Sandboxes_Updatebadge1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_updatebadge1 = /** @type {((inputs?: Sandboxes_Updatebadge1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Updatebadge1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_updatebadge1(inputs)
	if (locale === "ms") return ms_sandboxes_updatebadge1(inputs)
	if (locale === "da") return da_sandboxes_updatebadge1(inputs)
	if (locale === "de") return de_sandboxes_updatebadge1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_updatebadge1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_updatebadge1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_updatebadge1(inputs)
	if (locale === "fil") return fil_sandboxes_updatebadge1(inputs)
	if (locale === "fr") return fr_sandboxes_updatebadge1(inputs)
	if (locale === "it") return it_sandboxes_updatebadge1(inputs)
	if (locale === "hu") return hu_sandboxes_updatebadge1(inputs)
	if (locale === "nl") return nl_sandboxes_updatebadge1(inputs)
	if (locale === "no") return no_sandboxes_updatebadge1(inputs)
	if (locale === "pl") return pl_sandboxes_updatebadge1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_updatebadge1(inputs)
	if (locale === "pt") return pt_sandboxes_updatebadge1(inputs)
	if (locale === "ro") return ro_sandboxes_updatebadge1(inputs)
	if (locale === "fi") return fi_sandboxes_updatebadge1(inputs)
	if (locale === "sv") return sv_sandboxes_updatebadge1(inputs)
	if (locale === "vi") return vi_sandboxes_updatebadge1(inputs)
	if (locale === "tr") return tr_sandboxes_updatebadge1(inputs)
	if (locale === "cs") return cs_sandboxes_updatebadge1(inputs)
	if (locale === "bg") return bg_sandboxes_updatebadge1(inputs)
	if (locale === "ru") return ru_sandboxes_updatebadge1(inputs)
	if (locale === "uk") return uk_sandboxes_updatebadge1(inputs)
	if (locale === "ar") return ar_sandboxes_updatebadge1(inputs)
	if (locale === "hi") return hi_sandboxes_updatebadge1(inputs)
	if (locale === "th") return th_sandboxes_updatebadge1(inputs)
	if (locale === "ja") return ja_sandboxes_updatebadge1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_updatebadge1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_updatebadge1(inputs)
	return ko_sandboxes_updatebadge1(inputs)
});
export { sandboxes_updatebadge1 as "sandboxes.updateBadge" }